import { call, put, select, takeEvery } from 'redux-saga/effects'
import { toggleAreaType, setAllAreaTypes, setMapSettings, selectMapSettings } from 'src/redux/mapSettings'
import { MAP_AREA_TYPES } from 'src/redux/mapSettings/mapSettings.types'
import { setLocalStorageMapSettings } from 'src/redux/mapSettings/mapSettings.localStorage'

export function* toggleAreaTypeHandler(action: ReturnType<typeof toggleAreaType>) {
    const areaType = action.payload
    const mapSettings: ReturnType<typeof selectMapSettings> = yield select(selectMapSettings)
    const isAreaToggled = mapSettings.toggledAreaTypes.includes(areaType)
    const toggledAreaTypes = isAreaToggled
        ? mapSettings.toggledAreaTypes.filter(area => area !== areaType)
        : [...mapSettings.toggledAreaTypes, areaType]
    const newMapSettings = { toggledAreaTypes }

    yield call(setLocalStorageMapSettings, newMapSettings)
    yield put(setMapSettings(newMapSettings))
}

export function* setAllAreaTypesHandler(action: ReturnType<typeof setAllAreaTypes>) {
    const newMapSettings = { toggledAreaTypes: action.payload ? [...MAP_AREA_TYPES] : [] }

    yield call(setLocalStorageMapSettings, newMapSettings)
    yield put(setMapSettings(newMapSettings))
}

export default function* watcher() {
    yield takeEvery(toggleAreaType.toString(), toggleAreaTypeHandler)
    yield takeEvery(setAllAreaTypes.toString(), setAllAreaTypesHandler)
}
